<template>
  <div id="innercontainer" class="inner-container">
    <a-divider />

    <div id="CV" class="cv-section">
      <iframe
        src="/CV.pdf"
        title="Tianle Yang CV"
        class="cv-frame"
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeComponent',
  methods: {

  }
}
</script>

<style scoped>
.inner-container {
  width: 98%;
  height: 100%;
  margin: 0 auto;
}

.cv-section {
  width: 100%;
  height: 850px;
  margin-top: -10px;
  border: 1px solid #cccccc;
  background-color: white;
}

.cv-frame {
  width: 100%;
  height: 100%;
  border: none;
}
</style>